import styled from 'styled-components/macro'
import { transparentize } from 'polished'

export const Wrap = styled.aside`
  grid-area: Aside;
  padding: 0;
  display: none;
  background-color: ${(props) => props.theme.color.elementBg};
  border-right: 0.1rem solid ${(props) => props.theme.color.elementBorder};
  ${(props) => props.theme.breakpoints.greaterThan('md')`
    display: flex;
  `};
`

export const Container = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr auto;
  align-items: space-between;
`

export const List = styled.ul`
  margin: 0;
  padding: 0;
`

export const ListItem = styled.li`
  margin: 0;
  padding: 0;
  height: 4.6rem;
  font-weight: ${(props) => props.theme.font.weight.regular};
  font-size: 1.6rem;
  color: ${(props) => props.theme.color.textThird};
  border-bottom: 0.1rem solid ${(props) => props.theme.color.elementBorder};
  a {
    padding: 1.2rem 1.6rem;
    width: 100%;
    height: 100%;
    display: inline-flex;
    transition: color 0.26s ease, background-color 0.26s ease;
    &.activeNavLink {
      color: ${(props) => props.theme.color.text};
      background-color: ${(props) => transparentize(0.6, props.theme.color.success)};
    }
  }
`

export const ListItemButton = styled.button`
  position: relative;
  margin: 0;
  padding: 0;
  width: 100%;
  display: inline-flex;
  align-items: center;
  font-weight: inherit;
  font-size: inherit;
  color: inherit;
  background-color: ${(props) => props.theme.color.transparent};
  border: none;
  user-select: none;
  pointer-events: none;
`

export const Text = styled.h5`
  margin: 0;
  padding: 1.6rem;
  font-weight: ${(props) => props.theme.font.weight.medium};
  font-size: 1.6rem;
  line-height: 1.43;
  border-top: 0.1rem solid ${(props) => props.theme.color.elementBorder};
`

export const Badge = styled.span`
  position: absolute;
  right: 1.6rem;
  margin: 0;
  padding: 0;
  flex: 0 0 auto;
  font-weight: ${(props) => props.theme.font.weight.bold};
  font-size: 1.4rem;
  line-height: 1.43;
  color: ${(props) => props.theme.color.warning};
`
